const unaryOperators_405 = {"+": true, "-": true, "!": true, "~": true, "++": true, "--": true, typeof: true, void: true, delete: true};
const binaryOperatorPrecedence_406 = {"*": 13, "/": 13, "%": 13, "+": 12, "-": 12, ">>": 11, "<<": 11, ">>>": 11, "<": 10, "<=": 10, ">": 10, ">=": 10, in: 10, instanceof: 10, "==": 9, "!=": 9, "===": 9, "!==": 9, "&": 8, "^": 7, "|": 6, "&&": 5, "||": 4};
var operatorAssoc_407 = {"*": "left", "/": "left", "%": "left", "+": "left", "-": "left", ">>": "left", "<<": "left", ">>>": "left", "<": "left", "<=": "left", ">": "left", ">=": "left", in: "left", instanceof: "left", "==": "left", "!=": "left", "===": "left", "!==": "left", "&": "left", "^": "left", "|": "left", "&&": "left", "||": "left"};
export function operatorLt(left_408, right_409, assoc_410) {
  if (assoc_410 === "left") {
    return left_408 < right_409;
  } else {
    return left_408 <= right_409;
  }
}
export function getOperatorPrec(op_411) {
  return binaryOperatorPrecedence_406[op_411];
}
export function getOperatorAssoc(op_412) {
  return operatorAssoc_407[op_412];
}
export function isUnaryOperator(op_413) {
  return (op_413.isPunctuator() || op_413.isIdentifier() || op_413.isKeyword()) && unaryOperators_405.hasOwnProperty(op_413.val());
}
export function isOperator(op_414) {
  if (op_414.isPunctuator() || op_414.isIdentifier() || op_414.isKeyword()) {
    return binaryOperatorPrecedence_406.hasOwnProperty(op_414) || unaryOperators_405.hasOwnProperty(op_414.val());
  }
  return false;
}
